module.exports = __webpack_public_path__ + "img/sign-75.6ee058db.jpg";